export class CreateApplicationLocationWamsConstants {
    static STEP_TITLE = "Location";
    static DESCRIPTION_LABEL_1 = "Use the 'Search for place or address' bar on the right to search for your location. Draw a point, line or polygon on the map to indicate the location of the wayleave.";
    static DESCRIPTION_LABEL_2 = "If you would like to use the zoom function, use the 'Select tool' on the toolbar on the left to navigate to your location.";
    static TRUE_CENTROID = "True centroid gp shared-services";
    static LAYER_REF = "Wayleave graphics";
}
